import { createRouter, createWebHistory } from 'vue-router';
import RouteBuilder from './RouteBuilder';
import Manager from './Manager';
import PathAdapter from './PathAdapter';

export default class RouterFactory {
  public static create() {
    const manager = Manager.getInstance();

    RouteBuilder.langCodes = manager.langCodes;

    window.dispatchEvent(new CustomEvent('add-routes'));

    const { routes } = manager;

    const front = Manager.getInstance().submissions.list.length ? 'overview' : 'add-program';

    RouteBuilder.langCodes.forEach((langCode) => {
      routes.push({
        path: `/${langCode}`,
        redirect: `/${langCode}/${front}`,
      });
    });

    const router = createRouter({
      history: createWebHistory(),
      routes,
    });

    router.beforeEach((to, from, next) => {
      document.querySelector('body').setAttribute('data-path', PathAdapter.kebabCase(to.fullPath));

      if (to.meta.authenticated && !manager.user.getUid()) {
        Manager.getInstance().user.redirectToSignIn();
        return;
      }

      if (to.meta.onboarded && !Manager.getInstance().user.isOnboarded) {
        Manager.getInstance().user.onboard();
        return;
      }

      if (to.meta.onboarded === false && manager.isOnboarded && manager.user.getUid()) {
        const redirect = `/${manager.i18n.global.locale}/overview`;
        next(redirect);
        return;
      }

      const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);
      if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title as string;
      } else {
        document.title = manager.i18n.global.t('site-name-full');
      }

      next();
    });

    return router;
  }
}
